import getPartnerUrl from '@PROJECT_ROOT/assets/shared/js/partner/partnerUrl';
import { isFrame } from '@PROJECT_ROOT/assets/shared/js/isPartnerService';
import openUrl from '@PROJECT_ROOT/assets/shared/js/infrastructure/openUrl';

/**
 * Čini da se svi linkovi sa target="_blank" na FRAME servisima otvaraju u novom tabu, ali unutar partnerovog site-a
 * kao iframe.
 *
 * Ako ne može naći partnerov url, ignorira target="_blank" i otvara link unutar frame-a.
 *
 * Ne radi ništa ako nismo na frame servisu.
 */
export default function initializeNewTabLinks() {
    if (!isFrame()) {
        return;
    }

    // Handle-a slučaj ako korisnik slučajno otvori link preko npr. middle click-a ili "Open Link in New Tab" naredbe
    // unutar kontekst menu-a.
    //
    // Frame stranica će se otvoriti van frame-a, pa nema potrebe za posebnim otvaranjem u novom tabu.
    if (!isInsideIFrame()) {
        return;
    }

    /**
     * Čekamo do 1 sekundu na odgovor od partnerske skripte, nakon toga se getPartnerUrl() promise resolve-a sa null.
     */
    getPartnerUrl(1000).then((partnerUrl) => {
        document.addEventListener('click', (event) => {
            // Pomoću ovog kôda provjeravamo u testovima je li se listener uopće postavio
            if (process.env.NODE_ENV !== 'production') {
                const testElement = document.createElement('span');
                testElement.classList.add('js-test-attached-listener-called');
                document.body.appendChild(testElement);
            }

            const clickedLink = getLinkParentElement(event.target);

            if (clickedLink === null) {
                return;
            }

            // Ovdi revertam promenu potrebnu za native otvaranje u New tab kako bi staro otvaranje u novom tabu radilo
            const { hadHref } = clickedLink.dataset;
            if (hadHref && !clickedLink.classList?.contains('unitInfo')) {
                clickedLink.href = hadHref;
            }

            if (clickedLink.target !== '_blank') {
                return;
            }

            // TESTIRATI DA JE NAKON
            event.preventDefault();

            // Samo naše linkove želimo otvoriti u novom tabu *unutar partnerovog frame-a*, ako se radi o vanjskom linku
            // otvaramo ga direktno u novom tabu.
            if (clickedLink.href.indexOf(ADRIATIC_PARTNER_RESPONSIVE_SCHEME_HOST) !== 0
                && clickedLink.href.indexOf(ADRIATIC_PARTNER_MOBILE_SCHEME_HOST) !== 0
                && clickedLink.href.indexOf(ADRIATIC_PARTNER_SCHEME_HOST) !== 0
            ) {
                window.open(clickedLink.href, '_blank');

                return;
            }

            // Ako nema partnerskog url-a (stari frame ili skripta na partnerovoj stranici nije odgovorila na vrijeme),
            // ne želimo otvoriti url u novom tabu.
            if (partnerUrl === null) {
                openUrl(clickedLink.href);

                return;
            }

            const partnerUrlElement = document.createElement('a');
            partnerUrlElement.href = partnerUrl;

            // Replace je IE11 workaround jer pathname u IE nema početni "/"
            const hostAndPath = `${partnerUrlElement.hostname}/${partnerUrlElement.pathname}`.replace('//', '/');

            // Encoding je potreban jer izgleda da bez encodinga ne radi ispravno na nekim stranicama koje ne koriste
            // https.
            //
            // @see http://www.sajko-turizem.si/si/apartmaji-na-jadranu?vac-url=https://www.vacation-croatia.com/hr ne radi
            // @see http://www.sajko-turizem.si/si/apartmaji-na-jadranu?vac-url=https%3A%2F%2Fwww.vacation-croatia.com%2Fhr radi
            //
            // Ovo također stvara bug #38909 na https stranicama.
            const vacUrl = encodeURIComponent(clickedLink.href);

            const result = window.open(
                `${partnerUrlElement.protocol}//${hostAndPath}?vac-url=${vacUrl}${partnerUrlElement.hash}`,
                '_blank',
            );

            // Ako otvaranje u novom prozoru nije uspjelo, otvori url u ovom (za browsere koji znaju blokirat otvaranje
            // u novom prozoru)
            if (result === null) {
                openUrl(clickedLink.href);
            }
        });
    });
}

/**
 * @see https://www.geeksforgeeks.org/how-to-check-a-webpage-is-loaded-inside-an-iframe-or-into-the-browser-window-using-javascript/
 *
 * @return {Boolean}
 */
function isInsideIFrame() {
    return window.top !== window.self;
}

function getLinkParentElement(element) {
    // Došli smo do vrha HTML stabla bez da smo našli link, završavamo sa rekurzijom
    if (element === null) {
        return null;
    }

    // Našli smo link element, završavamo sa rekurzijom
    if (element.tagName === 'A') {
        return element;
    }

    return getLinkParentElement(element.parentElement);
}

function changeLinksForNativeBrowserLinkAndNewTabSupport() {
    if (!isFrame()) {
        return;
    }
    // Handle-a slučaj ako korisnik slučajno otvori link preko npr. middle click-a ili "Open Link in New Tab" naredbe
    // unutar kontekst menu-a.
    //
    // Frame stranica će se otvoriti van frame-a, pa nema potrebe za posebnim otvaranjem u novom tabu.
    if (!isInsideIFrame()) {
        return;
    }
    /**
     * Čekamo do 1 sekundu na odgovor od partnerske skripte, nakon toga se getPartnerUrl() promise resolve-a sa null.
     */
    getPartnerUrl(1000).then((partnerUrl) => {
        // Ako nema partnerskog url-a (stari frame ili skripta na partnerovoj stranici nije odgovorila na vrijeme),
        // ne želimo mjenjat linkove.
        if (partnerUrl === null) {
            return;
        }
        const handleNewLink = (link) => {
            const { href } = link;
            if (!(href.indexOf(ADRIATIC_PARTNER_RESPONSIVE_SCHEME_HOST) !== 0
                && href.indexOf(ADRIATIC_PARTNER_MOBILE_SCHEME_HOST) !== 0
                && href.indexOf(ADRIATIC_PARTNER_SCHEME_HOST) !== 0)
            ) {
                const partnerUrlElement = document.createElement('a');
                partnerUrlElement.href = partnerUrl;
                const hostAndPath = `${partnerUrlElement.hostname}/${partnerUrlElement.pathname}`.replace('//', '/');
                if (href.indexOf('#') === -1 && href !== window.location.href && href.indexOf('/google/') === -1 && !link.classList?.contains('languageChange') && !link.dataset?.page) {
                    const vacUrl = encodeURIComponent(href);
                    const updatedHref = `${partnerUrlElement.protocol}//${hostAndPath}?vac-url=${vacUrl}${partnerUrlElement.hash}`;
                    link.dataset.hadHref = href;
                    link.setAttribute('href', updatedHref);
                }
            }
        };
        const allLinks = document.querySelectorAll('a[href]');
        allLinks.forEach((link) => {
            handleNewLink(link);
        });

        // Set up the MutationObserver
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        // Check if the added node is an <a> element with an href
                        if (node.tagName === 'A' && node.hasAttribute('href')) {
                            handleNewLink(node);
                        }

                        // If the added node is a container, check its children
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            node.querySelectorAll('a[href]').forEach((link) => {
                                handleNewLink(link);
                            });
                        }
                    });
                }
            });
        });

        // Start observing the document body for added elements
        observer.observe(document.body, {
            childList: true, // Watch for direct children being added or removed
            subtree: true, // Also watch for changes in all descendants
        });
    });
}
changeLinksForNativeBrowserLinkAndNewTabSupport();
